import React from 'react'

interface DownloadableTitleProps {
  title: string
  // ariaLabel?: string
  className?: string
  style?: React.CSSProperties
  // onClick?: () => void
}

const montserratStyle = { fontFamily: 'Montserrat, sans-serif', color: '#1E1E1E' }

const DownloadableTitle: React.FC<DownloadableTitleProps> = ({
  title,
  // ariaLabel = 'Descargar CSV',
  className = '',
  style = {},
  // onClick,
}) => (
  <div
    className={`w-full mt-8 mb-4 flex items-center justify-between px-6 py-4 rounded bg-[#C9D296] ${className}`}
    style={style}
  >
    <span className="text-base font-bold" style={montserratStyle}>
      {title}
    </span>
  </div>
)

DownloadableTitle.defaultProps = {
  // ariaLabel: 'Descargar CSV',
  className: '',
  style: {},
  // onClick: undefined,
}

export default DownloadableTitle
